import React from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const CatergoryCard = ({ title, url }) => {
  const navigate = useNavigate();

  return (
    <Paper
      elevation={0}
      sx={{
        height: "100%",
        minHeight: 100,
        borderRadius: 3,
        border: "1px solid rgba(20, 83, 45, 0.12)",
        background: "linear-gradient(180deg, #ffffff 0%, #f8fbfa 100%)",
        p: 2,
      }}
    >
      <Stack spacing={1}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          spacing={1.5}
        >
          <Box
            sx={{
              width: "100%",
              textAlign: "center",
            }}
          >
            <Typography variant="h6" fontWeight={800}>
              {title}
            </Typography>
          </Box>
        </Stack>

        <Stack direction="row" spacing={1.25} sx={{ pt: 0.75 }}>
          <Button
            fullWidth
            variant="contained"
            onClick={() => navigate(url)}
            sx={{
              borderRadius: 2,
              fontWeight: 700,
              textTransform: "none",
              bgcolor: "#165c53",
              color: "#fff",
              "&:hover": {
                bgcolor: "#12483f",
              },
            }}
          >
            VER
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default CatergoryCard;
